export enum Page {
  CHARACTERS = 'characters',
  ENCOUNTER_EDIT = 'encounter_edit',
  ENCOUNTER_INITIATIVE = 'encounter_initiative',
  ENCOUNTER_COMBAT = 'encounter_combat',
  ENCOUNTERS_LIST = 'encounters_list',
  SETTINGS = 'settings',
}
